import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Question } from '../../models/QAndA';
import { useTranslation } from 'react-i18next';
import ExclamationIcon from 'icons/Exclamation.icon';
import { getUserFullName } from 'utils';

import './RejectionReasonBanner.styles.scss';
import './RejectionReasonBanner.styles.responsive.scss';

type RejectionReasonBannerProps = {
  className?: string;
  question: Question;
};

const RejectionReasonBanner: React.FC<RejectionReasonBannerProps> = (props) => {
  const { className, question } = props;
  const { t } = useTranslation();

  const classes = classNames('rejection-reason-banner', className);

  const [rejectionReason, rejectorName] = useMemo(
    () => [
      question.dataRoomAnswer?.rejectAnswerRespond,
      getUserFullName(
        question.dataRoomAnswer?.rejectedUser?.firstName,
        question.dataRoomAnswer?.rejectedUser?.lastName,
      ),
    ],
    [question],
  );

  if (!rejectorName) return null;

  return (
    <div className={classes}>
      <ExclamationIcon />
      <div>
        <p>
          {t('yourAnswerWasReturnedBy', {
            rejector: rejectorName,
          })}
        </p>
        <p>{rejectionReason}</p>
      </div>
    </div>
  );
};

export default RejectionReasonBanner;
